import React from 'react'

export default class ScrollTopOnMount extends React.Component {
  componentDidMount() {
    if (typeof window !== 'undefined') window.scrollTo(0, 0)
  }
  render() {
    return null
  }
}
